module.exports = __webpack_public_path__ + "img/64.689e25bc.jpg";